import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer4 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.iso");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/uploads/Certificate ISO 2700-2022_Mobile ID_20241209.pdf"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="Certificate ISO 2700-2022_Mobile ID_20241209"
      ></iframe>
    </div>
  );
};

export default PdfViewer4;
